import type { GameAudio } from 'yage/audio';

const EFFECTS = ['apt-build-complete', 'apt-build-upgrade', 'apt-construct-hammer',
  'apt-janitor-mop', 'apt-jet-landing', 'apt-jet-takeoff', 'apt-money-spent', 'apt-notify',
  'apt-pa-chime-3', 'apt-passenger-angry', 'apt-staff-hired', 'idle-cash-pickup',
  'apt-agent-typing-short', 'apt-agent-typing-long', 'apt-agent-typing-frantic', 'apt-bag-thud',
  'apt-card-tap', 'apt-key-solid', 'apt-passport-stamp', 'apt-radio-key', 'apt-scan-fail',
  'apt-scan-ok', 'apt-shop-till', 'apt-suitcase-zip', 'apt-tray-stack', 'apt-xray-belt',
  'apt-detector-alarm', 'apt-detector-pass', 'apt-footstep-tile', 'apt-milestone', 'apt-income-tick', 'apt-applause-small'];
let warming: Promise<void> | undefined;
let owner: GameAudio | undefined;

/** Prepare the game's repeated timbres before its simulation starts. */
export function prepareAirportAudio(audio: GameAudio): Promise<void> {
  if (owner === audio && warming) return warming;
  owner = audio;
  audio.onDispose(() => { if (owner === audio) { owner = undefined; warming = undefined; } });
  warming = (async () => {
    const results = await Promise.all([
      audio.prepare(EFFECTS),
      ...[0.08, 0.35, 0.85].map(thrust => audio.prepare(['apt-amb-jet-engine'], { params: { thrust } })),
      ...Array.from({ length: 9 }, (_, i) => audio.prepare(['apt-amb-apron'], { params: { activity: i / 8 } })),
    ]);
    const failure = results.flat().find(result => result.error);
    if (failure) throw failure.error;
  })();
  return warming;
}
